import { TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';
import {
  ColumnSettings,
  ColumnTypes,
  TableCellURLType,
  TableFilterType,
} from '@app/sharedModule/models/table-settings.model';
import { TrackService } from '../services/track.service';
import { ShippingStatus } from '@pdqdev/pdq-shared/dist/CarrierData';

export const trackColumnsConfig: ColumnSettings[] = [
  {
    type: ColumnTypes.CHECKBOX,
    prop: 'checkbox',
    hideColumnName: true,
    sortable: false,
    width: 35,
    minWidth: 35,
    maxWidth: 35,
  },
  {
    type: ColumnTypes.COLOR,
    prop: 'colorCoding',
    name: 'Color coding',
    filterType: TableFilterType.COLOR,
    filterOption: 'IN',
    filterValueArray: [],
    sortDirection: null,
    width: 70,
    minWidth: 70,
    maxWidth: 120,
    canBeHide: true,
    default: true,
  },
  {
    sortDirection: null,
    prop: 'orderNumber',
    name: 'Order no.',
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    width: 70,
    minWidth: 70,
    fraudRisk: true,
    pendingPayment: true,
    default: true,
    split: true,
    merged: true,
    canBeHide: true,
  },
  {
    prop: 'externalOrderNumber',
    name: 'External order number',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'itemCount',
    name: 'Items',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: true,
    canBeHide: true,
    internalStatus: true,
  },
  {
    prop: 'zone',
    name: 'Zone',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: false,
    canBeHide: true,
  },
  {
    type: ColumnTypes.DATE,
    prop: 'createdDate',
    name: 'Date ordered',
    width: 110,
    minWidth: 90,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    filterFields: 'createdDate',
    filterValue: '',
    sortDirection: null,
    default: true,
    headerTitleIcon: true,
    canBeHide: true,
  },
  {
    prop: 'shippingAddressFormatted',
    name: 'Ship to',
    width: 180,
    minWidth: 180,
    type: ColumnTypes.POPOVER_COLUMN,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    sortDirection: '',
    withNote: true,
    sortFieldName: ['customer.ordersCount'],
    withLoyalty: true,
    default: true,
  },
  {
    prop: 'shippingAddress.province',
    name: 'Ship to state',
    width: 120,
    minWidth: 120,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'shippingAddress.country',
    name: 'Ship to country',
    width: 140,
    minWidth: 140,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'customerFormated',
    name: 'Bill to',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    sortFieldName: ['customer.firstName'],
    canBeHide: true,
    default: true,
  },
  {
    prop: 'shipFromAddress.storeName',
    name: 'Inventory location',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.SELECT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shipFromAddress'],
    default: true,
    canBeHide: true,
    filterSelectOptions: [],
  },
  {
    prop: 'selectedCarrierName',
    name: 'Delivery service',
    width: 175,
    minWidth: 175,
    filterType: TableFilterType.SELECT,
    filterOption: 'LIKE',
    sortDirection: '',
    sortFieldName: ['orderBatch'],
    canBeHide: true,
    default: true,
  },
  {
    prop: 'deliveryTransaction.shippingPriceAmount',
    name: 'Shipping cost',
    type: ColumnTypes.DYNAMIC,
    filterType: TableFilterType.EMPTY,
    width: 110,
    minWidth: 130,
    maxWidth: 260,
    showOnCondition: false,
    canBeHide: true,
  },
  {
    type: ColumnTypes.DYNAMIC,
    filterType: TableFilterType.EMPTY,
    prop: 'deliveryTransaction.metadata.insurance.insuranceFee',
    name: 'Insurance fee',
    width: 70,
    minWidth: 70,
    showOnCondition: false,
    canBeHide: true,
  },
  {
    prop: 'deliveryTransaction.shippingId',
    name: 'Tracking Number',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterFields: 'shippingId',
    filterOption: 'LIKE',
    sortFieldName: ['deliveryTransaction.shippingId'],
    linkType: TableCellURLType.DELIVERY_TRACKING_URL,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'shippingInfo',
    name: 'Shipping info',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    sortDirection: '',
    sortFieldName: ['deliveryTransaction'],
    canBeHide: true,
    default: false,
  },
  {
    prop: 'batchName',
    name: 'Batch name',
    width: 110,
    minWidth: 90,
    filterType: TableFilterType.TEXT_DATE,
    filterOption: 'LIKE',
    sortDirection: '',
    sortFieldName: ['orderBatch'],
    canBeHide: true,
    default: true,
  },
  {
    prop: 'box.name',
    name: 'Package name',
    filterType: TableFilterType.SELECT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['box.name'],
    filterSelectOptions: [],
  },
  {
    prop: 'totalTagsCount',
    name: 'Tags',
    type: ColumnTypes.POPOVER_COLUMN,
    width: 80,
    minWidth: 80,
    filterType: TableFilterType.TAGS,
    filterOption: 'IN',
    filterValue: '',
    filterValueArray: [],
    default: false,
    sortDirection: '',
    canBeHide: true,
    tooltipText: 'View all tags',
    scrollSection: 'orderTagsId',
    zeroStateText: 'tag',
  },
  {
    prop: 'skus',
    name: `SKUs`,
    filterType: TableFilterType.TEXT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['skus'],
    tooltipText: 'View all skus',
    scrollSection: 'orderDetailsId',
    zeroStateText: 'SKU',
  },
  {
    prop: 'fulfillmentStatus',
    name: 'Fulfillment status',
    type: ColumnTypes.FULFILLMENT,
    width: 100,
    minWidth: 100,
    maxWidth: 120,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: TranslatedFulfillmentStatus.FULFILLED,
        text: 'Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.PARTIALLY_FULFILLED,
        text: 'Partially Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.NOT_FULFILLED,
        text: 'Unfulfilled',
      },
    ],
    filterOption: 'LIKE',
    sortDirection: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'deliveryTransaction.shippingStatus',
    name: 'Delivery status',
    type: ColumnTypes.SHIPPING_STATUS,
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.SELECT,
    getFilterOption: (col) => (col?.filterValue?.includes(ShippingStatus.MARK_AS_DELIVERED) ? 'NOT IN' : 'IN'),
    sortDirection: '',
    filterSelectOptions: TrackService.getShippingStatusFilterOptions(),
  },
  {
    prop: 'deliveryTransaction.fulfillmentDate',
    name: 'Fulfillment date',
    type: ColumnTypes.DATE,
    width: 110,
    minWidth: 90,
    filterType: TableFilterType.DATE,
    sortFieldName: ['deliveryTransaction.fulfillmentDate'],
    filterFields: 'deliveryTransaction.fulfillmentDate',
    filterOption: 'DATE RANGE',
    default: false,
    canBeHide: true,
  },
  {
    prop: 'deliveryMethod',
    name: 'Delivery method',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    default: false,
    canBeHide: true,
  },
  {
    type: ColumnTypes.TEXT,
    sortable: true,
    prop: 'orderShipmentFee',
    name: 'Charge for shipping',
    width: 70,
    minWidth: 70,
    canBeHide: true,
    default: false,
  },
  {
    prop: 'deliveryPromise',
    name: 'Delivery promise',
    type: ColumnTypes.DELIVERY_PROMISE,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    sortFieldName: ['deliveryDate'],
    filterFields: 'deliveryDate',
    width: 190,
    minWidth: 190,
    maxWidth: 260,
  },
];
//
// export const multiCarrierConfig: ColumnSettings[] = [
//   {
//     prop: 'deliveryTransaction.carrierProvidedByMultiCarrier',
//     name: 'Selected service',
//     type: ColumnTypes.TEXT,
//     filterType: TableFilterType.EMPTY,
//     width: 110,
//     minWidth: 130,
//     maxWidth: 260,
//   },
//   {
//     prop: 'deliveryTransaction.shippingPriceAmount',
//     name: 'Shipping cost',
//     type: ColumnTypes.TEXT,
//     filterType: TableFilterType.EMPTY,
//     width: 110,
//     minWidth: 130,
//     maxWidth: 260,
//   },
// ];
